import { render, staticRenderFns } from "./Caret.vue?vue&type=template&id=0240de5a&scoped=true&"
import script from "./Caret.vue?vue&type=script&lang=js&"
export * from "./Caret.vue?vue&type=script&lang=js&"
import style0 from "./Caret.vue?vue&type=style&index=0&id=0240de5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240de5a",
  null
  
)

export default component.exports